import { useEffect, useState } from 'react';

import { getArtworkRank } from '@/services';
import type { AssetRankMarketplace } from '@/types/asset';
import { PERIOD_ARTWORK_RANK } from '@/types/asset';
import { useSQuery } from '@/utils';

const useArtworkRank = () => {
  const [period, setPeriod] = useState<PERIOD_ARTWORK_RANK>(PERIOD_ARTWORK_RANK.hour);

  const { data, refetch } = useSQuery({
    queryKey: ['get-artwork-rank-trending'],
    queryFn: () => getArtworkRank({ size: 10, offset: 0, filter: JSON.stringify({ period }) }),
    keepPreviousData: true,
  });

  useEffect(() => {
    refetch();
  }, [period]);
  const list: AssetRankMarketplace[] = data?.data?.items || [];

  return { list, setPeriod, period };
};

export default useArtworkRank;
